import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: '1 0 auto',
    overflow: 'auto',
    fontFamily: theme.typography.fontFamily,
  },
}));

const ListContainer = forwardRef(function ListContainer(
  { className, children, ...restProps },
  ref
) {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} ref={ref} {...restProps}>
      {children}
    </div>
  );
});

ListContainer.propTypes = {
  className: Proptypes.string,
  children: Proptypes.arrayOf(Proptypes.node).isRequired,
};

ListContainer.defaultProps = {
  className: '',
};

ListContainer.displayName = 'ListContainer';

export default ListContainer;
